import { useState } from "react";
import { Link } from "react-router-dom";
import { LIST } from "@/constants/testIds";

const ratioToCss = (ratio) => (ratio === "16:9" ? "16/9" : ratio === "9:16" ? "9/16" : "1/1");

export const ListView = ({ projects, searchString, linkBase = "/work" }) => {
  const [hover, setHover] = useState(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  if (projects.length === 0) {
    return (
      <div data-testid="list-empty-state" className="py-24 text-center font-mono text-sm uppercase tracking-widest text-[#888880]">
        No projects match these filters
      </div>
    );
  }

  return (
    <div data-testid={LIST.container} className="max-w-5xl mx-auto px-4 sm:px-8 py-8 sm:py-10 divide-y divide-[#2A2A2A]">
      {projects.map((p, i) => (
        <Link
          key={p.slug}
          to={`${linkBase}/${p.slug}`}
          state={{ fromSearch: searchString }}
          data-testid={LIST.row(p.slug)}
          onMouseEnter={() => setHover(p)}
          onMouseLeave={() => setHover(null)}
          onMouseMove={(e) => setPos({ x: e.clientX, y: e.clientY })}
          className="group flex items-center justify-between gap-4 py-4 sm:py-5 hover:bg-[#181818] hover:pl-3 transition-all duration-200 min-h-[44px]"
        >
          <div className="flex items-baseline gap-3 sm:gap-5 min-w-0">
            <span className="text-sm text-[#555550] w-6 shrink-0">{String(i + 1).padStart(2, "0")}</span>
            <span className="text-sm sm:text-base tracking-tight text-[#F5F5F0] group-hover:text-[#CCFF00] truncate transition-colors">
              {p.title}
            </span>
          </div>
          <div className="hidden sm:flex items-center gap-4 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-[#888880] shrink-0">
            <span>{p.productionType}</span>
            <span>{p.category}</span>
            <span>{p.year}</span>
            {p.isDemo && <span className="text-[#CCFF00]">Demo</span>}
          </div>
        </Link>
      ))}
      {hover && (
        <div
          className="hidden md:block fixed z-40 pointer-events-none w-40 border border-[#CCFF00]/40 bg-black overflow-hidden"
          style={{ left: pos.x + 24, top: pos.y - 60, aspectRatio: ratioToCss(hover.aspectRatio) }}
        >
          <img src={hover.posterUrl} alt="" className="w-full h-full object-contain bg-black" />
        </div>
      )}
    </div>
  );
};

export default ListView;
